export const BLE_SEARCH_BEGAN = 'connection/BLE_SEARCH_BEGAN'
export const ADD_BLE_AVAILABLE = 'connection/ADD_BLE_AVAILABLE'
export const BLE_SEARCH_END = 'connection/BLE_SEARCH_END'
export const BLE_SEARCH_ERROR = 'connection/BLE_SEARCH_ERROR'


export const TCP_SEARCH_BEGAN = 'connection/TCP_SEARCH_BEGAN'
export const ADD_TCP_AVAILABLE = 'connection/ADD_TCP_AVAILABLE'
export const TCP_SEARCH_END = 'connection/TCP_SEARCH_END'
export const TCP_SEARCH_ERROR = 'connection/TCP_SEARCH_ERROR'